export const REGISTER_USER = `/user/new`;
export const LOGIN = `/login`;
export const INDEX = `/`;
export const PASSWORD_RECOVERY = `/password-recovery`;
export const CONFIRMPASSWORD = `/recoveryPassword`;
export const DECLARACION_JURADAS = `/declaracionJuradas`;
export const DECLARACION_JURADAS_NEW = `/declaracionJuradas/new`;
export const DECLARACION_JURADAS_SHOW = `/declaracionJuradas/show`;
export const AFILIADOS = `/afiliados`;
export const AFILIADOS_NEW = `/afiliados/new`;
export const AFILIADOS_EDIT = `/afiliados/edit`;
export const BOLETAS = `/boletas`;
export const BOLETAS_NEW = `/boletas/new`;
export const BOLETAS_PAY = `/boletas/pay`;
export const TICKET_ONDEMAND_NEW = `/boletas/onDemand/new`;
export const TICKET_ONDEMAND_REGENERATE = `/boletas/onDemand/regenerate`;
export const BOLETAS_REGENERATE = `/boletas/regenerate`;
export const EMPRESAS = `/empresas`;
export const EMPRESAS_NEW = `/empresas/new`;
export const EMPRESAS_EDIT = `/empresas/edit`;
export const HOLIDAYS = `/holidays`;
export const HOLIDAYS_NEW = `/holidays/new`;
export const HOLIDAYS_EDIT = `/holidays/edit`;
export const FIXED_CONTRIBUTIONS = `/fixedContributions`;
export const FIXED_CONTRIBUTIONS_NEW = `/fixedContributions/new`;
export const FIXED_CONTRIBUTIONS_EDIT = `/fixedContributions/edit`;
export const USER_CONTROL = `/userControl`;
export const USER_CONTROL_NEW = `/userControl/new`;
export const USER_CONTROL_EDIT = `/userControl/edit`;
export const CONFIRMEMAIL = `/confirm`;
export const RESEND_EMAIL_CONFIRM = `/reSendEmailConfirm`;
export const BI_COMPANY = `/biCompany`;
export const BI_AFFILIATE = `/biAffiliate`;
export const BI_PROVINCE = `/biProvince`;
export const PAYMENT_METHODS = `/paymentMethods`;
export const PAYMENT_METHODS_NEW = `/paymentMethods/new`;
export const PAYMENT_METHODS_EDIT = `/paymentMethods/edit`;
export const SUPPORT_TICKET_NEW = `/supportTicket/new`;
export const SUPPORT_TICKET_EDIT = `/supportTicket/edit`;
export const SUPPORT_TICKET = `/supportTicket`;
export const EMPRESA_MOVEMENTS = `/empresas/movements`;



// WEBPACK FOOTER //
// ./src/config/RoutesConstants.js